// animation
import { Fade } from "react-awesome-reveal";
// import icons
import { HearLogo } from "utils/Icons";

const StepTwo = ({ setActiveStep }) => {
  return (
    <>
      <div className="step_card_body">
        <Fade triggerOnce delay={500} duration={1200}>
          <HearLogo className="mx_auto" />
        </Fade>
        <br />
        <Fade triggerOnce delay={900} duration={1600}>
          <h3>
            You're certainly not alone.
          </h3>
        </Fade>
        <br />
        <Fade triggerOnce delay={1600} duration={1500}>
          <p>
            But don't worry...
            <br />
            <br />
            MamaZen helps thousands of moms daily, with the same struggles, transform their motherhood experience.
          </p>
        </Fade>
      </div>

      <div className="mt_auto screen_sticky_footer">
        <Fade triggerOnce delay={2200} duration={1700}>
          <button onClick={() => setActiveStep(2)} className="cs_btn w_100">
            Yes! Let's do this
          </button>
        </Fade>
      </div>
    </>
  );
};

export default StepTwo;
